import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/Images/logo-login.png'


const _hoisted_1 = { class: "hidden-mobile body-color" }
const _hoisted_2 = { class: "sign-up" }
const _hoisted_3 = { class: "container-fixed" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "justify-content-center align-items-center" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "sign-up__content__formulario__img" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-w-[80px] mt-5",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "mt-2 mb-2 align-items-center",
  section: ""
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-style" }, "Choose your perfect plan", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-style" }, "seelect the perfect plan that fits your needs", -1)
const _hoisted_12 = { class: "row justify-content-center mt-5 mb5" }
const _hoisted_13 = { class: "col-md-5 zoom" }
const _hoisted_14 = { class: "card monthly" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"color":"white"} }, "MONTHLY PAYMENT"),
  /*#__PURE__*/_createElementVNode("h2", { class: "price" }, [
    /*#__PURE__*/_createTextVNode("$48"),
    /*#__PURE__*/_createElementVNode("span", { class: "period" }, "/month")
  ])
], -1)
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("ul", { class: "feature-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "This is a recurring payment"),
  /*#__PURE__*/_createElementVNode("li", null, "Cancel anytime")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "col-md-5 zoom" }
const _hoisted_20 = { class: "card yearly" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"color":"white"} }, "ANNUAL PAYMENT (Recommended)"),
  /*#__PURE__*/_createElementVNode("h2", { class: "price" }, [
    /*#__PURE__*/_createTextVNode("$450"),
    /*#__PURE__*/_createElementVNode("span", { class: "period" }, "/year")
  ])
], -1)
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("ul", { class: "feature-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Save $126 compared to the monthly plan"),
  /*#__PURE__*/_createElementVNode("li", null, "Equivalent to $37.50 / month"),
  /*#__PURE__*/_createElementVNode("li", null, "One single payment per year")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  key: 1,
  class: "mt-2 mb-2 align-items-center",
  section: ""
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-style" }, "Choose your perfect plan.", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-style" }, "Select the perfect plan that fits your needs.", -1)
const _hoisted_28 = { class: "row justify-content-center mt-5 mb5" }
const _hoisted_29 = { class: "col-md-5 zoom" }
const _hoisted_30 = { class: "card monthly" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"color":"white"} }, "MONTHLY PAYMENT"),
  /*#__PURE__*/_createElementVNode("h2", { class: "price" }, [
    /*#__PURE__*/_createTextVNode("$48"),
    /*#__PURE__*/_createElementVNode("span", { class: "period" }, "/month")
  ])
], -1)
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("ul", { class: "feature-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "This is a recurring payment"),
  /*#__PURE__*/_createElementVNode("li", null, "Cancel anytime")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "col-md-5 zoom" }
const _hoisted_36 = { class: "card yearly" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"color":"white"} }, "ANNUAL PAYMENT (Recommended)"),
  /*#__PURE__*/_createElementVNode("h2", { class: "price" }, [
    /*#__PURE__*/_createTextVNode("$450"),
    /*#__PURE__*/_createElementVNode("span", { class: "period" }, "/year")
  ])
], -1)
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("ul", { class: "feature-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Save $126 compared to the monthly plan"),
  /*#__PURE__*/_createElementVNode("li", null, "Equivalent to $37.50 / month"),
  /*#__PURE__*/_createElementVNode("li", null, "One single payment per year")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = {
  key: 2,
  class: "mt-2 mb-2 align-items-center",
  section: ""
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "text-style" }, "Choose your perfect plan.", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "text-style" }, "Select the perfect plan that fits your needs.", -1)
const _hoisted_44 = { class: "row justify-content-center mt-5 mb5" }
const _hoisted_45 = { class: "col-md-5 zoom" }
const _hoisted_46 = { class: "card yearly" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"color":"white"} }, "ANNUAL PAYMENT"),
  /*#__PURE__*/_createElementVNode("h2", { class: "price" }, [
    /*#__PURE__*/_createTextVNode("$140"),
    /*#__PURE__*/_createElementVNode("span", { class: "period" }, "/year")
  ])
], -1)
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("ul", { class: "feature-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "One single payment per year")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = {
  key: 3,
  class: "mt-2 mb-2 align-items-center",
  section: ""
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "text-style" }, "Choose your perfect plan.", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "text-style" }, "Select the perfect plan that fits your needs.", -1)
const _hoisted_54 = { class: "row justify-content-center mt-5 mb5" }
const _hoisted_55 = { class: "col-md-5 zoom" }
const _hoisted_56 = { class: "card monthly" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"color":"white"} }, "MONTHLY PAYMENT"),
  /*#__PURE__*/_createElementVNode("h2", { class: "price" }, [
    /*#__PURE__*/_createTextVNode("$48"),
    /*#__PURE__*/_createElementVNode("span", { class: "period" }, "/month")
  ])
], -1)
const _hoisted_58 = { class: "card-body" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("ul", { class: "feature-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "This is a recurring payment"),
  /*#__PURE__*/_createElementVNode("li", null, "Cancel anytime")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "col-md-5 zoom" }
const _hoisted_62 = { class: "card yearly" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"color":"white"} }, "ANNUAL PAYMENT (Recommended)"),
  /*#__PURE__*/_createElementVNode("h2", { class: "price" }, [
    /*#__PURE__*/_createTextVNode("$450"),
    /*#__PURE__*/_createElementVNode("span", { class: "period" }, "/year")
  ])
], -1)
const _hoisted_64 = { class: "card-body" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("ul", { class: "feature-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Save $126 compared to the monthly plan"),
  /*#__PURE__*/_createElementVNode("li", null, "Equivalent to $37.50 / month"),
  /*#__PURE__*/_createElementVNode("li", null, "One single payment per year")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import axios from 'axios';
import { ref, computed, onMounted } from 'vue';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";
import { useRoute, useRouter } from 'vue-router';

//COMPONENTS
import VueNumberFormat from "vue-number-format";

import { useToast } from "@/composables/useToast";

export default /*#__PURE__*/_defineComponent({
  __name: 'TypePayment',
  setup(__props) {

const toast = useToast();
const route = useRoute();
const router = useRouter();
//VARIABLES
const url = environment.URL_API;
const loading = ref(false);
const formSubmitted = ref(false);

const typeUser = Number(route.query.type);
const userId = Number(route.query.userId);


const submitUser = async (subscriptionType) => {
  loading.value = true;

  const interval = subscriptionType=== 'monthly' ? 'month': 'year';

  router.push({
    path: "/register/payment",
    query: {
      type: typeUser,
      userId: userId,
      interval: interval
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              class: "w-100",
              onSubmit: _withModifiers(submitUser, ["prevent"])
            }, [
              _hoisted_7,
              _hoisted_8,
              (_ctx.$route.query.type == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-primary mt-3 mb-4",
                              style: {"width":"400px"},
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (submitUser('monthly')))
                            }, " SUBSCRIBE "),
                            _hoisted_18
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-primary mt-3 mb-4",
                              style: {"width":"400px"},
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (submitUser('yearly')))
                            }, " SUBSCRIBE "),
                            _hoisted_24
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$route.query.type == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-primary mt-3 mb-4",
                              style: {"width":"400px"},
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (submitUser('monthly')))
                            }, " SUBSCRIBE "),
                            _hoisted_34
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-primary mt-3 mb-4",
                              style: {"width":"400px"},
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (submitUser('yearly')))
                            }, " SUBSCRIBE "),
                            _hoisted_40
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$route.query.type == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _hoisted_42,
                    _hoisted_43,
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, [
                            _hoisted_49,
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-primary mt-3 mb-4",
                              style: {"width":"400px"},
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (submitUser('yearly')))
                            }, " SUBSCRIBE "),
                            _hoisted_50
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$route.query.type == 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _hoisted_52,
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createElementVNode("div", _hoisted_58, [
                            _hoisted_59,
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-primary mt-3 mb-4",
                              style: {"width":"400px"},
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (submitUser('monthly')))
                            }, " SUBSCRIBE "),
                            _hoisted_60
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("div", _hoisted_64, [
                            _hoisted_65,
                            _createElementVNode("button", {
                              type: "submit",
                              class: "btn btn-primary mt-3 mb-4",
                              style: {"width":"400px"},
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (submitUser('yearly')))
                            }, " SUBSCRIBE "),
                            _hoisted_66
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 40, _hoisted_6)
          ])
        ])
      ])
    ])
  ]))
}
}

})